import kvSyncSubscriber from '@/mqtt/kvSync'
import SlideApi from '@/api/slide'

const getAttributeChangesTopic = ({ presentationId }) => {
  return `presentation-${presentationId}-slide-attributes/#`
}
const slideAttributesAction = {
  subscribeAttributeChanges: async (
    { commit },
    { presentationId },
  ) => {
    if (!presentationId) return
    const callbackWrapper = (topic, message) => {
      // For reference: the topic is form in general-api
      // services-layer/slide-service
      const regex = /slide-(\d+)-(.+)$/
      const match = topic.match(regex)
      if (!match) return
      const [, slideId, attributeKey] = match
      const attributeValue = JSON.parse(message)
      const attributeUpdated = { [attributeKey]: attributeValue }
      commit('updateAttributes', { presentationId, slideId, attributes: attributeUpdated })
    }
    const key = getAttributeChangesTopic({ presentationId })
    kvSyncSubscriber.subscribeKey(key, callbackWrapper)
  },
  unsubscribeAttributeChanges: (_, { presentationId }) => {
    kvSyncSubscriber.unsubscribeKey(getAttributeChangesTopic({ presentationId }))
  },
  bulkUpdateAttributes: async (
    { commit },
    { presentationId, slides },
  ) => {
    if (!presentationId || !slides?.length) return
    await SlideApi.bulkUpsertSlideAttributes({ presentationId, slides })
    slides.forEach(({ id, slideAttributes }) => {
      commit('updateAttributes', {
        presentationId,
        slideId: id,
        attributes: slideAttributes,
      })
    })
  },
  getByKeys: async (
    { commit, dispatch },
    { presentationId, attributeKeys },
  ) => {
    if (!presentationId || !attributeKeys?.length) return
    const resp = await dispatch(
      'getSlideAttributesByPresentationId',
      { presentationId, attributeKeys: attributeKeys.join(',') },
      { root: true },
    )
    if (!Array.isArray(resp)) return
    const requestedKeys = new Set(attributeKeys)
    resp.forEach((row) => {
      if (!row.type || !row.attributes || !requestedKeys.has(row.type)) return
      commit('updateAttributes', {
        presentationId,
        slideId: row.slideId,
        attributes: { [row.type]: row.attributes },
      })
    })
  },
}

export default slideAttributesAction
